import { Breadcrumbs } from '@/components/Breadcrumbs';
import { CONTENT_SPACE_CLASSNAME, EMPTY_META, FRONT_URL } from '@/constants';
import { Layout } from '@/layout';
import { InferGetServerSidePropsType } from 'next';
import styles from './Service.module.scss';
import { BannerStatic } from '@/components/BannerStatic';
import { Title } from '@/components/Title';
import { BannerSpace } from '@/components/BannerSpace';
import { Map } from '@/components/Map';
import { Divider } from '@/components/Divider';
import { useClientTranslations } from '@/hooks/useClientTranslations';
import { fetchData } from '@/services/fetchData';
import { useTranslations } from '@/hooks/useTranslations';
import Head from 'next/head';

export default function Service({
  seo,
  description,
  banners,
  services,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const t = useClientTranslations();
  const { getTranslations } = useTranslations();
  const firstImage = banners[0];

  return (
    <>
      <Head>
        <link rel="canonical" href={`${FRONT_URL}/service`} />
      </Head>
      <Layout meta={seo}>
        <main className={styles.main}>
          <Breadcrumbs
            routes={[
              { link: '/service', text: getTranslations(description.title) },
            ]}
            className={styles.breadcrumbs}
          />
          <Title
            text={getTranslations(description.title)}
            className={styles.title}
            heading
          />
          <BannerStatic
            heading={getTranslations(description.title)}
            image={firstImage ? firstImage.mediaFile : ''}
            mobileImage={firstImage ? firstImage.mobileMediaFile : ''}
            tabletImage={firstImage ? firstImage.tabletMediaFile : ''}
            className={styles.banner}
            absolute
          />
          <BannerSpace />
          <div
            className={CONTENT_SPACE_CLASSNAME}
            dangerouslySetInnerHTML={{
              __html: getTranslations(description.body),
            }}
          />
          <div className={styles.mapContainer}>
            <div className={styles.info}>
              <div className={styles.block}>
                <span className={styles.subtitle}>{t.service.contacts}</span>
                <div className={styles.infoText}>
                  {/* {t.service.address} */}
                  {getTranslations(services?.town) +
                    ' ' +
                    getTranslations(services?.address)}
                  <br />
                  <br />
                  Телефоны для справок: <br />
                  {services?.phones?.map((phone: any, index: number) => (
                    <p style={{ marginTop: '6px' }} key={index}>
                      {phone.number}
                    </p>
                  ))}
                  <br />
                  <br />
                  E-mail: {services?.email}
                </div>
              </div>
              <Divider />
              <div className={styles.block}>
                <span className={styles.subtitle}>
                  {t.service.workingHours}
                </span>
                {services?.workTime && (
                  <div className={styles.infoText}>
                    {getTranslations(services?.workTime)}
                    {/* <br />
                  <br />
                  {t.service.weekend} */}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.map}>
              <span className={styles.subtitle}>{t.service.map}</span>
              <Map />
            </div>
          </div>
        </main>
      </Layout>
    </>
  );
}

export async function getServerSideProps() {
  const descriptionRes = await fetchData({
    url: '/descriptionBlock/page/services',
  });
  const seoRes = await fetchData({
    url: '/seo/page/services',
  });
  const bannersRes = await fetchData({
    url: '/banner/list?pages=services',
  });
  const servicesRes = await fetchData({
    url: '/service/list',
  });

  if (!descriptionRes.success) return { notFound: true };

  return {
    props: {
      seo: seoRes.data ?? EMPTY_META,
      description: descriptionRes.data,
      banners: bannersRes.data.results,
      services: servicesRes.data.results[0],
    },
  };
}
